import { useMemo } from "react";
import { useTheme } from "@mui/material/styles";

export function useAvatarColors(userId) {
  const theme = useTheme();
  const numericId = Number(userId);

  const avatarColors = useMemo(
    () => [
      theme.palette.secondary.main,
      theme.palette.primary.primaryMark,
      theme.palette.tertiary.tertiaryMark,
      theme.palette.error.errorMark,
      theme.palette.natural.naturalMark,
      theme.palette.primary.onPrimaryContainer,
      theme.palette.warning.onWarningContainer,
      theme.palette.tertiary.onTertiaryContainer,
      theme.palette.error.onErrorContainer,
    ],
    [theme],
  );

  const textColors = useMemo(
    () => [
      theme.palette.primary.onPrimary,
      theme.palette.primary.onPrimaryContainer,
      theme.palette.tertiary.onTertiaryContainer,
      theme.palette.error.onErrorContainer,
      theme.palette.surface.onSurface,
      theme.palette.primary.primaryMark,
      theme.palette.warning.warningMark,
      theme.palette.tertiary.tertiaryMark,
      theme.palette.error.errorMark,
    ],
    [theme],
  );

  return useMemo(() => {
    if (numericId === 1) {
      return {
        color: theme.palette.warning.warningMark,
        textColor: theme.palette.warning.onWarningContainer,
      };
    }
    if (!numericId || isNaN(numericId)) {
      return {
        color: theme.palette.surface.onSurfaceMark,
        textColor: theme.palette.surface.onSurface,
      };
    }

    const index = (numericId - 2) % avatarColors.length;
    return {
      color: avatarColors[index],
      textColor: textColors[index],
    };
  }, [numericId, theme, avatarColors, textColors]);
}
